let Backbone = require("backbone");
let _ = require("underscore");

let main = function (Backbone, _) {
    return Backbone.Model.extend({
        defaults: {
            paymentReceipt: false,
            orderReceipt: false,
            itemSlip: false,
            returnSlip: false,
            dispatchSlip: false
        },
        isPrintable: function () {
            return _.some(_(this.toJSON()).values());
        }
    });
};

let exportedValue = main(Backbone, _);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/settings/PrintSettingModel.js